import { Col, Flex, Form, Row } from "antd";
import React, { useState } from "react";
import { CustomButton, CustomInput } from "../../../components";
import { useSpin } from "../../../components/SpinContext";
import { push, ref } from "firebase/database";
import { db } from "../../../api's/firebase";

const validateEmail = (_, value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value || emailRegex.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Please enter a valid email address"));
};

const WhitePaperDownload = ({ closeModal }) => {
  const [form] = Form.useForm();
  const { showSpin, hideSpin } = useSpin();

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSubmit = (values) => {
    showSpin();
    const newData = {
      name: values.name,
      company: values.email,
    };

    push(ref(db, "whitepaper"), newData)
      .then((response) => {
        const link = document.createElement("a");
        link.href = "https://zoomlogiwhitepaper.s3.us-west-1.amazonaws.com/White+Paper_ZoomLogi_Loss+Rate.pdf";
        link.download = "White_Paper_ZoomLogi_Loss_Rate.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        form.resetFields();

        closeModal();
      })
      .catch((error) => {
        console.error("Error adding new data: ", error);
      }).finally(() => {
        hideSpin();
    });
  };

  const validateNoWhitespace = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject(new Error("This field cannot be empty or contain only whitespace"));
    }
    return Promise.resolve();
  };

  return (
    <div>
      <Form form={form}
        name="basic"
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Flex vertical gap="middle">
          <Form.Item
            className="custom-input"
            label="Your Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please input your name",
              },
              {
                validator: validateNoWhitespace,
              },
            ]}
          >
            <CustomInput
              placeholder="First and last"
              height="36px"
              border="0px"
              bgColor="#f3f3f3"
              textColor="#5E5E5E"
              borderRadius="8px"
              placeholderColor="#5E5E5E"
              lineHeight="38px"
            />
          </Form.Item>

          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email address",
              },
              {
                validator: validateNoWhitespace,
              },
              {
                validator: validateEmail,
              },
            ]}
          >
            <CustomInput
              placeholder="Your email address"
              height="36px"
              border="0px"
              bgColor="#f3f3f3"
              textColor="#5E5E5E"
              borderRadius="8px"
              placeholderColor="#5E5E5E"
              lineHeight="38px"
            />
          </Form.Item>

          <Flex gap="16px" justify="end">
            <CustomButton
              key="button1"
              text={"Cancel"}
              bgColor="transparent"
              color="black"
              fontSize="16px"
              fontWeight="500"
              boxShadow="none"
              height="48px"
            />
            <CustomButton
              text={"Download"}
              bgColor="black"
              color="white"
              height="48px"
              width="100px"
              fontSize="16px"
              fontWeight="500"
              boxShadow="none"
              borderRadius="8px"
              htmlType='submit'
            />
          </Flex>
        </Flex>
      </Form>
    </div>
  );
};

export default WhitePaperDownload;
